import * as RadixCheckbox from "@radix-ui/react-checkbox"
import classNames from "classnames"
import React from "react"
import styled from "styled-components"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"
import { useSizing } from "../helpers/use-sizing"
import { Icon } from "./icon"
type RadixCheckboxProps = React.ComponentProps<typeof RadixCheckbox.Root>
interface CheckboxProps extends Omit<RadixCheckboxProps, "defaultChecked" | "checked" | "onCheckedChange"> {
  checked: boolean | undefined
  onCheckedChange(checked: boolean | undefined): void
}

interface Props extends PrimitiveBaseProps<HTMLLabelElement>, PrimitiveWithSizing, CheckboxProps {
  label?: string
}

const StyledRoot = styled("label")<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  user-select: none;
  ${(props) => props.$disabled && "opacity: 40%;"}
`

const StyledCheckbox = styled(RadixCheckbox.Root)`
  all: "unset";
  background-color: white;
  border: 1px solid #a2a9b0;
  width: 18px;
  height: 18px;
  border-radius: 2px;
  &[data-state="checked"] {
    border: 1px solid ${(props) => props.theme.colors.primary};
  }
`

const StyledIndicator = styled(RadixCheckbox.Indicator)`
  color: white;
  background: ${(props) => props.theme.colors.primary};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledText = styled("span")`
  margin-left: 8px;
`

export function Checkbox(props: Props) {
  const {
    className,
    innerRef,
    label,
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    checked,
    disabled,
    onCheckedChange,
    ref, // unused
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)

  return (
    <StyledRoot
      $disabled={!!disabled}
      className={classNames(className, sizingClassName)}
      ref={innerRef}
      data-node-id={dataNodeId}
    >
      <StyledCheckbox checked={checked} onCheckedChange={onCheckedChange as any} disabled={disabled} {...otherProps}>
        <StyledIndicator>
          <Icon name="FeatherCheck" />
        </StyledIndicator>
      </StyledCheckbox>
      {label && <StyledText>{label}</StyledText>}
    </StyledRoot>
  )
}
